import { SessionStorageManager } from "@src/infrastructure/services/sessionStorage";
import type { ISerializationPort } from "@src/domain/ports";
import {
  SESSION_STORAGE_CLEAR_ERROR_CONFIG,
  SESSION_STORAGE_DELETE_ERROR_CONFIG,
  StorageAdapterBase,
} from "../storage/StorageAdapterBase";

export class SessionStorageAdapter extends StorageAdapterBase {
  constructor(serializer: ISerializationPort, prefix: string = "irAppAdmin") {
    super(
      new SessionStorageManager(prefix),
      serializer,
      SESSION_STORAGE_DELETE_ERROR_CONFIG,
      SESSION_STORAGE_CLEAR_ERROR_CONFIG
    );
  }
}

